import PageNav from "../../Components/PageNav";
import Dashboard from "../../Components/Dashboard";
import useNewDataFetcher from "../../Hooks/newUseDataFetcher";
import "./style.scss";

function ExecutiveDailyView() {
  const { data: apiData, isReady } = useNewDataFetcher({ endPoint: "/api/v1/dashboard/executive" });
  let { json, data } = apiData || { json: [], data: [] };
  return (
    <>
      <PageNav title="Executive: Daily View" />
      <Dashboard json={json} data={data} isReady={isReady} />
    </>
  );
}

export default ExecutiveDailyView;
